const useListColumns = () => {
  return [
    {
      Header: "Wallet Address",
      accessor: "walletAddress",
    },
    {
      Header: "Artist Name",
      accessor: "artistName",
    },
    {
      Header: "ENS Name",
      accessor: "ensName",
    },
    {
      Header: "Verified",
      accessor: "verified",
      disableGlobalFilter: true,
    },
    {
      Header: "Featured",
      accessor: "featured",
      disableGlobalFilter: true,
    },
    {
      Header: "Banned",
      accessor: "banned",
      disableGlobalFilter: true,
    },
    {
      Header: "Created At",
      accessor: "createdAt",
      disableGlobalFilter: true,
      sortType: (rowA: any, rowB: any) => rowA.original._createdAtTs - rowB.original._createdAtTs,
    },
    {
      Header: "",
      accessor: "actions",
      disableSortBy: true,
      disableGlobalFilter: true,
    },
  ];
};

export default useListColumns;
